export function englishCountryName (country) {
  switch (country) {
    case 'Niemcy':
      return 'Germany'
    case 'Holandia':
      return 'Netherlands'
    case 'Wielka Brytania':
      return 'United Kingdom'
    case 'Austria':
      return 'Austria'
    case 'Belgia':
      return 'Belgium'
    case 'Irlandia':
      return 'Ireland'
    default:
      return country
  }
}

export function countryCode (country) {
  switch (country) {
    case 'Niemcy':
      return 'DE'
    case 'Holandia':
      return 'NL'
    case 'Wielka Brytania':
      return 'UK'
    case 'Austria':
      return 'AUS'
    case 'Belgia':
      return 'BEL'
    case 'Irlandia':
      return 'IRE'
    default:
      return country
  }
}
